import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { ParquetCopySource } from 'app/model/pipeline/copysource/parquet.source';
import { convertStoreSettingsToResource, convertStoreSettingsToModel } from './store-read-settings/store-read-settings.util';
import { convertFormatSettingsToResource, convertFormatSettingsToModel } from './format-read-settings/format-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ParquetCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class ParquetCopySourceAdapter extends CopySourceAdapter<ParquetCopySource, Model.ParquetSource> {

    protected override async _toResource(copySource: ParquetCopySource): Promise<Model.ParquetSource> {
        const result: Model.ParquetSource = this.getCommonCopySourceProperties(copySource, 'ParquetSource');
        result.readerWildcardPath = ValueAdapter.toResource(copySource, ParquetCopySource.READER_WILDCARDPATH);
        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);
        return result;
    }

    protected override async _toModel(source: Model.ParquetSource, copyActivity: CopyActivity): Promise<ParquetCopySource> {
        const result = this.createCopySourceWithCommonProperties(ParquetCopySource.MODEL, source, copyActivity) as ParquetCopySource;
        ValueAdapter.toModel(result, ParquetCopySource.READER_WILDCARDPATH, source.readerWildcardPath);

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        return result;
    }
}
